import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BELOW_TABLET_MQ, DESKTOP_UP_MQ } from './loginOverlay.constants';

type FooterProps = {
	privacyLabel: string;
	privacyHref: string;
	imprintLabel: string;
	imprintHref: string;
	copyrightLabel: string;
};

const Footer = ({ privacyLabel, privacyHref, imprintLabel, imprintHref, copyrightLabel }: FooterProps) => {
	const isBelowTablet = useMediaQuery(BELOW_TABLET_MQ);

	return (
		<Box
			sx={{
				mt: { xs: 15, sm: 15 },
				pt: { xs: 3, sm: 3.5 },
				pb: { xs: 4, sm: 4 },
				display: 'flex',
				flexWrap: 'nowrap',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 2,
				color: 'text.secondary',
				[DESKTOP_UP_MQ]: {
					mt: 0,
					pt: 4,
					pb: 4,
					justifyContent: 'space-between'
				}
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexWrap: 'nowrap',
					justifyContent: 'flex-start',
					columnGap: 4,
					rowGap: 0
				}}
			>
				<Link href={privacyHref} color="inherit" underline="hover" sx={{ textUnderlineOffset: '3px' }}>
					<Typography variant="caption" sx={{ color: 'inherit', textAlign: 'left' }}>
						{privacyLabel}
					</Typography>
				</Link>
				<Link href={imprintHref} color="inherit" underline="hover" sx={{ textUnderlineOffset: '3px' }}>
					<Typography variant="caption" sx={{ color: 'inherit', textAlign: 'left' }}>
						{imprintLabel}
					</Typography>
				</Link>
			</Box>

			<Typography variant="caption" sx={{ color: 'inherit', textAlign: 'right', whiteSpace: 'nowrap' }}>
				{isBelowTablet ? '© 2026' : copyrightLabel}
			</Typography>
		</Box>
	);
};

export default Footer;
